/* istanbul ignore file */
import { useFormContext } from 'framework/form';
import { Button, ButtonProps } from 'framework/ui/mui-builder';

const SubmitFormButton = (props: ButtonProps) => {
  const { submitForm = () => {}, isSubmitEnabled } = useFormContext();
  return <Button {...props} onClick={() => submitForm()} disabled={!isSubmitEnabled} />;
};

export default SubmitFormButton;
